/**
 * File: useTodayMoneyController.ts
 * Path: apps/admin/src/features/today/hooks/useTodayMoneyController.ts
 * Description: The one money line on Today: Owed to you and Still to bill
 * from the shared helper (the same figures as Clients, the client page and
 * Money), and the bank balance from the books. Without the books Owed to you
 * is "unavailable" and the bank is left out; Today never falls back to the
 * contracts.
 */

import { useMemo } from "react";
import { DEFAULT_YEAR_END_MONTH } from "@idk/config";
import { useInvoiceLedger, useOwedFigures } from "@/shared/hooks/useInvoiceLedgerQueries";
import { headline } from "@/shared/utils/overviewFiguresUtils";
import { BOOKS_START } from "@/features/today/utils/todayOverviewUtils";

export const useTodayMoneyController = () => {
  const figures = useOwedFigures();
  const { ledger, journals, accounts, today } = useInvoiceLedger();
  const bankCents = useMemo(
    () =>
      ledger && ledger !== "unavailable"
        ? headline(journals, accounts, { from: BOOKS_START, to: today }, DEFAULT_YEAR_END_MONTH, BOOKS_START).bankCents
        : null,
    [ledger, journals, accounts, today],
  );
  return { owed: figures.owed, toBill: figures.toBill, bankCents };
};
